export const HEADER_HIGHLIGHT_COLOR = '#448AFF'
export const HEADER_HIGHLIGHT_WEIGHT = 700
export const HEADER_NORMAL_COLOR = '#475669'
export const HEADER_NORMAL_WEIGHT = 500

export const MIN_FOC_DATE = 3

export const COMMENTS_COLORS =
    {
        "Update": "#ffd04b",
        "Decline": "#FE2E2E",
        "Accept": "#47cf2b"
    }

export const DOMAIN_OVERRIDES = {
    "qa-porting.carrierx.int": {
        "logo": "carrierx-logo.svg",
        "email": "porting@carrierx.com",
    },
    "porting.carrierx.com": {
        "logo": "carrierx-logo.svg",
        "email": "porting@carrierx.com",
    },
    "qa-porting.hdcarrierholdings.int": {
        "logo": "hdcarrier-logo.png",
        "email": "porting@hdcarrier.com",
        "logo_style": "height:50px; width: 200px; background: rgb(255,255,255)"
    },
    "porting.hdcarrierholdings.com": {
        "logo": "hdcarrier-logo.png",
        "email": "porting@hdcarrier.com",
        "logo_style": "height:50px; width: 200px; background: rgb(255,255,255)"
    },
    "qa-porting.widevoice.int": {
        "logo": "widevoice-logo.svg",
        "email": "portout@widevoice.com",
        "logo_style": "height:50px; width: 70px;",
        "body_class": "widevoice-body"
    },
    "porting.widevoice.com": {
        "logo": "widevoice-logo.svg",
        "email": "portout@widevoice.com",
        "logo_style": "height:50px; width: 70px;",
        "body_class": "widevoice-body"
    }
}
export const DEFAULT_LOGO = "carrierx-logo.svg"
export const DEFAULT_BODY_OVERLOAD = "carrierx-body"
export const DEFAULT_EMAIL = "porting@carrierx.com"
export const DEFAULT_STYLE = "height:50px; width: 200px;"
